/**
 * TabContentLayout
 * Shared layout wrapper for tab content components
 */

import { makeStyles, tokens } from '@fluentui/react-components'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
    padding: tokens.spacingVerticalM,
  },
})

export interface TabContentLayoutProps {
  children: React.ReactNode
}

export function TabContentLayout({ children }: TabContentLayoutProps) {
  const styles = useStyles()

  return <div className={styles.root}>{children}</div>
}
